module.exports = __webpack_public_path__ + "img/25.51cfab30.png";